const header = document.getElementById("header");

const aboutBtn = $('#aboutBtn');
const aboutMenu = $('#aboutMenu');
const companyBtn = $('#companyBtn');
const companyMenu = $('#companyMenu');
const serviceBtn = $('#serviceBtn');
const serviceMenu = $('#serviceMenu');
const careersBtn = $('#careersBtn');
const careersMenu = $('#careersMenu');

const megaMenu = $('.megaMenu');
const megaMenuBg = $('#megaMenuBg');
const bgHide = $('.bgHide');

const navBtn = $('#navBtn');
const navMenu = $('#navMenu');
const menuToggle = $('.spGlobalNavItem .headerAccordionBtn');

const indexTop = $('#indexTop').length;

const subNavPage = $('#subNav').length;
const subNav = document.getElementById('subNav');

let menuOpenFlg = 0;
let scrTopFlg = 0;
let scrollPosition;

export function headerNavFunc() {

  aboutBtn.on({
    'mouseenter': function () {
      aboutMenu.addClass('isShow');
      header.classList.remove('changeColor');
      if (megaMenuBg.hasClass('isShow')) {
        aboutMenu.addClass('isFast');
      } else {
        megaMenuBg.addClass('isShow');
      }
    }
  });

  $(".pcGlobalNav>ul>li:not('#aboutBtn')").on('mouseover', function () {
    aboutMenu.removeClass('isShow');
  });

  companyBtn.on({
    'mouseenter': function () {
      companyMenu.addClass('isShow');
      header.classList.remove('changeColor');
      if (megaMenuBg.hasClass('isShow')) {
        companyMenu.addClass('isFast');
      } else {
        megaMenuBg.addClass('isShow');
      }
    }
  });

  $(".pcGlobalNav>ul>li:not('#companyBtn')").on('mouseover', function () {
    companyMenu.removeClass('isShow');
  });

  careersBtn.on({
    'mouseenter': function () {
      careersMenu.addClass('isShow');
      header.classList.remove('changeColor');
      if (megaMenuBg.hasClass('isShow')) {
        careersMenu.addClass('isFast');
      } else {
        megaMenuBg.addClass('isShow');
      }
    }
  });

  $(".pcGlobalNav>ul>li:not('#careersBtn')").on('mouseover', function () {
    careersMenu.removeClass('isShow');
  });

  $("main,.headerLogo").on('mouseover', function () {
    megaMenu.removeClass('isShow');
    megaMenu.removeClass('isFast');
    megaMenuBg.removeClass('isShow');
    if (scrTopFlg == 1) {
      header.classList.add('changeColor');
    }
  });

  document.body.addEventListener("mouseleave", () => {
    megaMenu.removeClass('isShow');
    megaMenu.removeClass('isFast');
    megaMenuBg.removeClass('isShow');
    if (scrTopFlg == 1) {
      header.classList.add('changeColor');
    }
  }, false);

  bgHide.on({
    'mouseenter': function () {
      megaMenuBg.removeClass('isShow');
      megaMenu.removeClass('isFast');
      header.classList.remove('changeColor');
    }
  });

  document.addEventListener("mousewheel", () => {
    megaMenu.removeClass('isShow');
    megaMenu.removeClass('isFast');
    megaMenuBg.removeClass('isShow');
    if (scrTopFlg == 1 && menuOpenFlg == 0) {
      header.classList.add('changeColor');
    }
  });
  document.addEventListener("touchmove", () => {
    megaMenu.removeClass('isShow');
    megaMenu.removeClass('isFast');
    megaMenuBg.removeClass('isShow');
    if (scrTopFlg == 1 && menuOpenFlg == 0) {
      header.classList.add('changeColor');
    }
  });

  navBtn.on('click', function () {
    navBtn.toggleClass('isOpen');
    if (navBtn.hasClass('isOpen')) {
      scrollPosition = $(window).scrollTop();
      menuOpenFlg = 1;
      navMenu.addClass('isShow');
      header.classList.remove('changeColor');
      $('.headerContents').addClass('isShow');
      $('body').addClass('fixedBody').css({
        'top': -scrollPosition
      });
    } else {
      menuOpenFlg = 0;
      navMenu.removeClass('isShow');
      $('.headerContents').removeClass('isShow');
      $('body').removeClass('fixedBody').css({
        'top': 0
      });
      window.scrollTo(0, scrollPosition);
      if (scrTopFlg == 1) {
        header.classList.add('changeColor');
      }
    }
  });

  menuToggle.on('click', function () {
    if ($(this).hasClass('isOpen')) {
      $(this).next('dd').slideUp(500);
      $(this).removeClass('isOpen');
    } else {
      menuToggle.next('dd').slideUp(500);
      menuToggle.removeClass('isOpen');
      $(this).next('dd').slideDown(500);
      $(this).addClass('isOpen');
    }
  });

  function indexHeaderScrFunc(){
    let scrTop = $(window).scrollTop();
    if (menuOpenFlg == 0) {
      if (scrTop < 20) {
        scrTopFlg = 1;
        header.classList.add('changeColor');
        header.classList.remove('changeHeight');

        if (subNavPage) {
          subNav.classList.remove('notTop');
        }

      } else {
        scrTopFlg = 0;
        header.classList.remove('changeColor');
        header.classList.add('changeHeight');

        if (subNavPage) {
          subNav.classList.add('notTop');
        }
      }
    }
  }
  function bottomHeaderScrFunc(){
    let scrTop = $(window).scrollTop();
    if (menuOpenFlg == 0) {
      if (scrTop < 20) {
        header.classList.remove('changeHeight');

        if (subNavPage) {
          subNav.classList.remove('notTop');
        }
      } else {
        header.classList.add('changeHeight');

        if (subNavPage) {
          subNav.classList.add('notTop');
        }
      }
    }
  }

  if (indexTop) {
    scrTopFlg = 1;

    indexHeaderScrFunc();
    $(window).on('scroll', function () {
      indexHeaderScrFunc();
    });
  } else {
    bottomHeaderScrFunc();
    $(window).on('scroll', function () {
      bottomHeaderScrFunc();
    });
  }
}

export function headerScrFunc() {
  console.log('スクロールで呼ばれます。');
}